import { createSelector } from '@reduxjs/toolkit';

import { getColorFromCapacityRatio } from '../../capacityColors';
import { RootState } from '..';
import { getActiveAnalysisSet } from './getActiveAnalysisSetSelector';
import { getActiveColorByOption } from './getColorFromMemberDefinitionSelector';
import { getHighestCapacityForItem } from './getHighestCapacityForItemSelector';
import { ComponentItemType } from './getSelectedItemSelector';

export const getObjectCapacityColor = createSelector(
  (state: RootState) => state,
  getActiveColorByOption,
  getActiveAnalysisSet,
  (state, colorByOption, analysisSet) => (itemObject: { itemGuid: string; itemType: ComponentItemType }) => {
    if (colorByOption === 'Combined' && analysisSet) {
      const capacity = getHighestCapacityForItem(state, itemObject.itemGuid, itemObject.itemType);
      return capacity ? getColorFromCapacityRatio(capacity) : null;
    }
    return undefined;
  },
);
